import * as a from '@mitranim/js/all.mjs'
import * as dr from '@mitranim/js/dom_reg.mjs'
import * as u from './util.mjs'
import {E, A} from './util.mjs'
import * as d from './dat.mjs'
import * as em from './elem-misc.mjs'
import * as eb from './elem-btn.mjs'
import * as ei from './elem-input.mjs'
import * as eff from './elem-form-field.mjs'
import * as effc from './elem-form-field-checkbox.mjs'

export class FormFieldSelectMulti extends eff.FormField {
  static {dr.reg(this)}
  get Input() {return FormFieldInputSelectMulti}

  initFromSpec(src) {
    src = a.toInst(src, d.UiField)
    return E(super.init(), {},
      new this.Label(this).initFromSpec(src),
      new this.Input(this).initFromSpec(src),
    )
  }

  connectedCallback() {
    super.connectedCallback()
    this.onchange = this.onChange
  }

  onChange() {this.input()?.updateSummary()}
}

/*
Semi-placeholder / incomplete implementation.

Missing features:

  * The "summary" should be a preview of selected selectables (title if one,
    count if multiple).

  * Search field, filtering selectables by title and/or value.
*/
class FormFieldInputSelectMulti extends ei.MixFormElem(em.DetailsNative) {
  static {dr.reg(this)}
  get FormFieldCheckbox() {return effc.FormFieldCheckboxMulti}
  checkboxInputs() {return u.selAll(this, `input[type=checkbox]`)}

  initFromSpec(spec) {
    spec = a.toInst(spec, d.UiField)
    const drawSel = sel => this.drawSel(sel, spec)

    return this
      .init(A.cls(`form-field`))
      .autoClosing()
      .appendSummary()
      .appendTooltipBody(a.map(spec.selectables, drawSel))
      .updateSummary()
  }

  drawSel(sel, spec) {
    if (a.isSome(sel.value)) return this.drawOption(sel, spec)
    return this.drawClear()
  }

  /*
  TODO: consolidate with the behaviors of `FormFieldOption`:

    * Add `.setSelected` method.

    * Encode the spec values exactly the same way as we encode option values,
      and compare the resulting strings. This would be simpler (no need to
      deep-walk structured data), and consistent with how the DOM compares
      value strings on any change events.
  */
  drawOption(sel, spec) {
    const val = a.renderLax(sel.value)
    const tar = new this.FormFieldCheckbox(this)

    return E(tar, A,
      new tar.Input(tar).init({
        name: spec.name,
        value: val,
        checked: a.includes(spec.value, val),
      }),
      new tar.Label(tar).init(A, sel.title || val)
    )
  }

  drawClear() {
    return E(
      new BtnClearAnc(),
      A.button().cls(`btn-border --tiny`),
      `Clear`,
    )
  }

  clear() {this.cleared()}
  cleared() {return a.fold(this.checkboxInputs(), 0, uncheckCount) > 0}

  appendTooltipBody(...chi) {
    if (a.vac(chi)) {
      this.append(E(`div`, A.cls(`select-list-parent --right pad-sm col-sta-sta gap-tiny`), ...chi))
    }
    return this
  }

  updateSummary() {
    const tar = this.summary()
    if (!tar) return this

    const empty = `No selection`
    const sels = a.reqArr(this.sels())

    if (sels.length === 1) {
      const val = u.selTitle(sels[0])
      tar.textContent = val ? `Selected: ` + val : empty
    }
    else if (sels.length > 1) {
      tar.textContent = `Selected: ` + sels.length
    }
    else {
      tar.textContent = empty
    }
    return this
  }

  sels() {
    const out = []
    for (const src of a.descendants(this, this.FormFieldCheckbox)) {
      const input = src.input()
      const label = src.label()
      if (input?.checked) out.push({value: input.value, title: label?.textContent})
    }
    return out
  }
}

function uncheckCount(acc, val) {
  a.reqNat(acc)
  a.reqElement(val)
  if (!val.checked) return acc
  val.checked = false
  return acc + 1
}

class BtnClearAnc extends eb.Btn {
  static {dr.reg(this)}

  perform() {
    const anc = this.findAnc(u.isClearer)
    /*
    This was added because programmatically altering `input.checked` does not
    dispatch a DOM change event. For now, we dispatch it manually. May
    reconsider in the future.
    */
    if (anc && anc.cleared()) u.dispatchChange(anc)
  }
}
